import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=bb26f83a&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=ts"
export * from "./HomeDetail.vue?vue&type=script&lang=ts"
import style0 from "./HomeDetail.vue?vue&type=style&index=0&id=bb26f83a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb26f83a",
  null
  
)

export default component.exports